/* Fun Cases — Back in Stock notify (Klaviyo).
   Self-contained: watches the PDP add-to-bag button; when the selected variant is
   sold out it injects a "🔔 Email me when it's back" button. The popup subscribes
   the email to Klaviyo's Back in Stock for the EXACT variant (client API — the
   public company_id is read from the Klaviyo onsite script tag). Klaviyo's
   "Back in Stock" flow then emails automatically when Shopify inventory returns. */
(function () {
  'use strict';
  var pdp = document.querySelector('[data-pdp]');
  var addBtn = document.querySelector('[data-pdp-submit]');
  if (!pdp || !addBtn) return;

  function companyId() {
    var s = document.querySelector('script[src*="klaviyo.com"][src*="company_id="]');
    var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    return (m && m[1]) || 'MCbw6E';
  }
  function variantId() {
    var el = document.querySelector('[data-pdp-variant-id]');
    return el ? el.value : null;
  }
  function variantLabel() {
    var bits = [];
    document.querySelectorAll('[data-pdp-options] .pdp-option input:checked').forEach(function (i) { bits.push(i.value); });
    var model = document.querySelector('[data-pdp-options]');
    var mv = model && model.getAttribute('data-model-value');
    if (mv) bits.unshift(mv);
    return bits.join(' · ');
  }

  /* ---------- notify button ---------- */
  // Visibility is controlled with an INLINE display style, never the [hidden]
  // attribute — theme CSS on the shared .btn class overrides [hidden]'s UA rule,
  // which made the button show on every product on the first deploy.
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'btn fc-bis-btn';
  btn.innerHTML = '🔔 Sold out — email me when it’s back in stock';
  btn.style.display = 'none';
  addBtn.insertAdjacentElement('afterend', btn);

  var css = document.createElement('style');
  css.textContent =
    '.fc-bis-btn{width:100%;margin-top:10px;background:var(--sky,#35bdf2);border:2px solid var(--ink,#161616);border-radius:14px;padding:14px 18px;font-weight:800;font-size:16px;cursor:pointer;box-shadow:var(--pop-shadow-sm,3px 3px 0 #161616);}' +
    '.fc-bis{position:fixed;inset:0;z-index:400;display:flex;align-items:center;justify-content:center;background:rgba(22,22,22,.5);}' +
    '.fc-bis[hidden]{display:none;}' +
    '.fc-bis__card{background:var(--cream,#fff);border:3px solid var(--ink,#161616);border-radius:20px;box-shadow:6px 6px 0 rgba(22,22,22,.9);max-width:400px;width:calc(100% - 32px);padding:24px;text-align:center;font-family:inherit;}' +
    '.fc-bis__card h3{margin:0 0 6px;font-size:22px;}' +
    '.fc-bis__sub{margin:0 0 14px;font-size:14px;opacity:.8;}' +
    '.fc-bis__card input[type=email]{width:100%;border:2px solid var(--ink,#161616);border-radius:12px;padding:12px 14px;font-size:16px;margin-bottom:12px;box-sizing:border-box;}' +
    '.fc-bis__send{width:100%;background:var(--sun,#ffc933);border:2px solid var(--ink,#161616);border-radius:14px;padding:13px 18px;font-weight:800;font-size:16px;cursor:pointer;box-shadow:3px 3px 0 #161616;}' +
    '.fc-bis__card{position:relative;}.fc-bis__x{position:absolute;top:8px;right:12px;background:none;border:none;font-size:22px;line-height:1;cursor:pointer;padding:4px;}' +
    '.fc-bis__msg{margin-top:10px;font-size:14px;font-weight:700;}' +
    '.fc-bis-hide{display:none !important;}';
  document.head.appendChild(css);

  /* ---------- modal ---------- */
  var modal = document.createElement('div');
  modal.className = 'fc-bis';
  modal.hidden = true;
  modal.innerHTML =
    '<div class="fc-bis__card" role="dialog" aria-modal="true" aria-label="Back in stock notification">' +
      '<button type="button" class="fc-bis__x" data-bis-close aria-label="Close">✕</button>' +
      '<h3>🔔 We’ll email you</h3>' +
      '<p class="fc-bis__sub" data-bis-label></p>' +
      '<input type="email" placeholder="your@email.com" data-bis-email autocomplete="email">' +
      '<button type="button" class="fc-bis__send" data-bis-send>Notify me when it’s back</button>' +
      '<p class="fc-bis__msg" data-bis-msg hidden></p>' +
    '</div>';
  document.body.appendChild(modal);
  modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-bis-close]')) modal.hidden = true; });

  function subscribe(email, vid) {
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL'],
        },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } },
      },
    };
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + companyId(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload),
    });
  }

  btn.addEventListener('click', function () {
    var vid = variantId();
    var v = null;
    try { v = JSON.parse((pdp.querySelector('[data-pdp-variants]') || {}).textContent || '[]').find(function (x) { return String(x.id) === String(vid); }); } catch (e) {}
    modal.querySelector('[data-bis-label]').textContent = (v && (v.options || []).join(' · ')) || variantLabel() || 'This item';
    modal.dataset.vid = vid || '';
    var msg = modal.querySelector('[data-bis-msg]');
    msg.hidden = true;
    modal.hidden = false;
    modal.querySelector('[data-bis-email]').focus();
  });

  modal.querySelector('[data-bis-send]').addEventListener('click', function () {
    var email = modal.querySelector('[data-bis-email]').value.trim();
    var msg = modal.querySelector('[data-bis-msg]');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { msg.textContent = 'Please enter a valid email.'; msg.hidden = false; return; }
    var vid = modal.dataset.vid || variantId();
    if (!vid) { msg.textContent = 'Something went wrong — please refresh and try again.'; msg.hidden = false; return; }
    subscribe(email, vid).then(function (r) {
      if (r.ok || r.status === 202) {
        msg.textContent = '🎉 Done — we’ll email you the moment it’s back.';
        msg.hidden = false;
        setTimeout(function () { modal.hidden = true; }, 2200);
      } else {
        return r.json().then(function (j) {
          msg.textContent = 'Could not save that — ' + ((j.errors && j.errors[0] && j.errors[0].detail) || 'please try again.');
          msg.hidden = false;
        });
      }
    }).catch(function () { msg.textContent = 'Network problem — please try again.'; msg.hidden = false; });
  });

  /* ---------- visibility: follow the add-to-bag sold-out state ---------- */
  function syncBtn() {
    var soldOut = addBtn.disabled && /sold out/i.test(addBtn.textContent || '');
    // Write styles only when they actually change — the observer watches addBtn, so an
    // unconditional style write would re-fire it in a loop.
    var want = soldOut ? 'block' : 'none';
    if (btn.style.display !== want) btn.style.display = want;         // inline style — nothing overrides it
    var wantAdd = soldOut ? 'none' : '';
    if (addBtn.style.display !== wantAdd) addBtn.style.display = wantAdd;   // one blue button replaces Sold out
    // A sold-out variant can't be personalised — hide the trigger (and any saved-design card).
    document.querySelectorAll('.pz-open, [data-pz-preview]').forEach(function (el) {
      el.classList.toggle('fc-bis-hide', soldOut);
    });
  }
  new MutationObserver(syncBtn).observe(addBtn, { attributes: true, childList: true, subtree: true });
  syncBtn();

  /* ---------- greyed-out option pills ----------
     The theme DISABLES option values with no sellable variant (e.g. S25 + Bumper),
     so the Sold-out button state is never reached for those. Clicking a greyed pill
     opens the notify popup for that exact combination instead of doing nothing. */
  var variants = [];
  try { variants = JSON.parse((pdp.querySelector('[data-pdp-variants]') || {}).textContent || '[]'); } catch (e) {}
  function variantForPill(pill) {
    var inp = pill.querySelector('input[data-opt-pos]');
    if (!inp || !variants.length) return null;
    var want = {};
    pdp.querySelectorAll('.pdp-option input:checked').forEach(function (c) {
      if (c.getAttribute('data-opt-pos')) want[c.getAttribute('data-opt-pos')] = c.value;
    });
    want[inp.getAttribute('data-opt-pos')] = inp.value;   // override with the greyed value
    var wrap = pdp.querySelector('[data-pdp-options]');
    var mp = wrap && parseInt(wrap.getAttribute('data-model-pos') || '0', 10);
    var mv = wrap && wrap.getAttribute('data-model-value');
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      if (mp && mv && v.options[mp - 1] !== mv) ok = false;
      if (ok) { for (var p in want) { if (v.options[parseInt(p, 10) - 1] !== want[p]) { ok = false; break; } } }
      if (ok) return v;
    }
    return null;
  }
  pdp.addEventListener('click', function (e) {
    var pill = e.target.closest('.pdp-opt-pill.is-unavailable');
    if (!pill) return;
    var v = variantForPill(pill);
    if (!v) return;
    e.preventDefault();
    modal.querySelector('[data-bis-label]').textContent = (v.options || []).join(' · ');
    modal.dataset.vid = v.id;
    var msg = modal.querySelector('[data-bis-msg]');
    msg.hidden = true;
    modal.hidden = false;
    modal.querySelector('[data-bis-email]').focus();
  });
})();
